import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <div className="m-3 lg:m-10 w-auto">
        <div className="bg-mgray ">
          <div className="container mx-auto px-4 py-20">
            <h1 className="text-3xl font-bold  text-mblack font-mfont mb-4">
              {" "}
              Terms & Conditions
            </h1>

            <p className="mb-4 font-mfont text-xl text-mblack font-medium">
              This Terms & Conditions sets out how our website uses and protects
              any information that you give us when you use this website.
            </p>

            <h2 className="text-2xl font-mfont text-mblack font-bold mb-2">
              Information We Collect
            </h2>

            <p className="mb-4 font-mfont text-xl text-mblack font-medium">
              We may collect the following information:
            </p>

            <ul className="list-disc text-mblack font-mfont list-inside mb-4">
              <li className="font-mfont font-medium text-xl">
                » Making Minds Technologies approves design and develop a website at Client’s
                request and will deliver the job by to the settled conditions.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Client is solely responsible for describing the detailed
                structure, number of pages required, and other relevant terms
                and conditions.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Client agrees to supply the Making Minds Technologies with satisfactory
                photography or imagery to use in the design.
              </li>
              <li className="font-mfont font-medium text-xl">
                {" "}
                » Client is responsible for obtaining and buying a Domain Name.
                Making Minds Technologies may at its discretion instruct Client on suitable
                names.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Client hereby admits that Making Minds Technologies is not accountable for
                any errors, grammatical or otherwise found in the material
                provided by client.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Making Minds Technologies agrees to resolve any errors or implement
                revisions requested by Client. Client agrees that a maximum of
                three revisions are available(depending on package). Major
                changes in design won’t be done in revisions.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Client acknowledges that any change requests after final
                approval has been given to Making Minds Technologies or after website is live
                will be charged. Making Minds Technologies will not begin work on following
                change requests until full payment has been received.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Client admits that Making Minds Technologies will add a “Web Design” by
                “Making Minds Technologies” link to the footnote section of each website they
                work on. This is branding of Making Minds Technologies and to eliminate it
                will charge.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Due to business nature, Making Minds Technologies will not be liable if
                your website got hacked, lost rankings or errors etc.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Clients can cancel website development or digital marketing
                project if the team of Making Minds Technologies has not started work and
                won’t accept any cancellation after 1 calendar day.
              </li>
              <li className="font-mfont font-medium text-xl">
                » Once the website is live then paid support will be provided at
                the rate of 500 Rs+18% GST.
              </li>
            </ul>

            <p className="mb-4 mt-10 font-mfont text-xl  font-semibold">
              Note – Any terms agreed in final proposal/email will also be
              considered along with terms mentioned in this term page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
